module.exports = __webpack_public_path__ + "img/CustomFields-3.bcfbfecf.png";